<div *ngIf="!progress && offersList.length" class="page-container">
  <section class="desktop-container d-none d-md-block">
    <div class="container pad-top-30 pad-bot-40 desktop-mid">
      <div class="f600 flex align-center mb-4" (click)="backClicked()">
        <img
          class="mr-2 back-btn"
          src="https://images.poshvine.com/icon/left-arrow.svg"
          alt="left arrow"
        />
        <ng-container i18n>Back</ng-container>
      </div>
      <div class="offer-details flex">
        <div class="col-lg-3 p-0 left-part">
          <div class="offer-det-img">
            <img
              class="img-fluid"
              loading="lazy"
              default="https://images.poshvine.com/b/default-thumbnail-image.jpg"
              [src]="offersList[0]?.attributes?.image_url"
            />
          </div>
          <div class="det-left pad-bot-15" *ngIf="merchant">
            <div class="merchant-title pad-15 pb-1 fnt-20 f500 text-white">
              <ng-container i18n>About</ng-container
              >{{ " " + merchant?.attributes?.name }}
            </div>
            <div class="pad-15 merchant-desc text-white">
              <div
                class="merchant-desc text-white"
                [ngClass]="{ 'truncate-desc': !readMore }"
                #merchantDescription
                [ngStyle]="{ 'max-height': readMore ? 'fit-content' : '120px' }"
                [innerHTML]="merchant?.attributes?.description"
              ></div>
              <ng-container
                *ngIf="merchant?.attributes?.description && showReadMoreButton"
              >
                <span
                  i18n
                  class="read-more pointer"
                  *ngIf="merchant?.attributes?.description && !readMore"
                  (click)="
                    readMore = !readMore; sendMerchantAnalyticsData('knowmore')
                  "
                  >Read more</span
                >
                <span
                  i18n
                  class="read-more pointer"
                  *ngIf="merchant?.attributes?.description && readMore"
                  (click)="
                    readMore = !readMore; sendMerchantAnalyticsData('knowmore')
                  "
                  >Read less</span
                >
              </ng-container>
            </div>
            <div
              class="visit-merchant-btn pad-left-15 pad-right-15"
              *ngIf="merchant?.attributes?.website"
            >
              <a
                (click)="sendMerchantAnalyticsData('go_to_website')"
                i18n
                target="_blank"
                rel="noreferrer noopener"
                class="ga-to-merchant flex align-center justify-center btn text-white"
                [href]="merchant?.attributes?.website"
                >Go to website</a
              >
            </div>
          </div>
        </div>
        <div class="offer-det col-lg-9 p-0">
          <div class="merchant-name-logo flex align-center mar-bot-20 bg-white">
            <div class="mer-l">
              <img
                class="img-fluid"
                loading="lazy"
                default="https://images.poshvine.com/b/default-thumbnail-square.jpg"
                [src]="merchant?.attributes?.logo_url"
              />
            </div>
            <div class="mer-title f500 fnt-26">
              {{ merchant?.attributes?.name }}
            </div>
          </div>

          <div
            class="single-offer-disp no-margin bg-fff relative"
            [class.claimed]="each?.voucherData"
            *ngFor="let each of offersList"
          >
            <div
              *ngIf="each?.voucherData"
              class="claimed-code absolute align-center justify-center pad-left-15 pad-right-15"
            >
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 0.0180664C4.032 0.0180664 0 4.05813 0 9.03606C0 14.014 4.032 18.0541 9 18.0541C13.968 18.0541 18 14.014 18 9.03606C18 4.05813 13.968 0.0180664 9 0.0180664ZM7.2 13.5451L2.7 9.03606L3.969 7.76452L7.2 10.993L14.031 4.14831L15.3 5.42886L7.2 13.5451Z"
                  fill="white"
                />
              </svg>
              <span i18n class="mar-left-10 f500">Claimed</span>
            </div>
            <div class="flex single-inside">
              <div class="col-lg-8">
                <h3 class="offer-title fnt-20 mar-bot-15">
                  {{ each.attributes.title }}
                </h3>
                <div
                  class="offer-desc"
                  [innerHtml]="each.attributes.description"
                ></div>
              </div>
              <div class="col-lg-4">
                <div
                  *ngIf="loadingRedemptions"
                  class="flex load-contain pad-right-35 pad-top-20 w100"
                >
                  <div class="loader1 dot-spin"></div>
                </div>
                <div
                  *ngIf="!loadingRedemptions"
                  class="offer-coupon-code mar-bot-20 flex justify-end"
                >
                  <div class="offer-coupon-code mar-bot-20 flex justify-end">
                    <ng-container *ngIf="_authService.isAuthenticated()">
                      <button
                        id="gtm-offer-detail-claim-btn"
                        class="primary-btn btn brand-btn w100 claim-btn"
                        (click)="redeem(each)"
                        [disabled]="each.showLoader"
                      >
                        <div class="d-flex align-center justify-content-center">
                          <div i18n>Claim offer</div>
                          <div
                            class="loader mar-left-10"
                            *ngIf="each.showLoader"
                          ></div>
                        </div>
                      </button>
                    </ng-container>
                    <ng-container *ngIf="!_authService.isAuthenticated()">
                      <button
                        id="gtm-offer-detail-claim-btn"
                        class="primary-btn btn brand-btn w100 claim-btn"
                        (click)="redeem(each)"
                      >
                        <div class="d-flex align-center justify-content-center">
                          <div i18n>Claim offer</div>
                        </div>
                      </button>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="offer-below-row-parent fnt-15">
              <div
                class="flex align-center justify-content-between offer-below-row w100 mar-top-10"
              >
                <div class="flex align-center offer-below-lft">
                  <ng-container *ngIf="each.attributes.end_date">
                    <img
                      src="https://images.poshvine.com/icon/calendar.svg"
                      alt="calendar"
                      class="mr-2"
                    />
                    <span class="mar-right-4"
                      ><ng-container i18n>Valid till</ng-container> : </span
                    ><b>
                      {{
                        each.attributes.end_date
                          | date
                            : (locale === "zh-TW"
                                ? "MMM dd日, yyyy"
                                : "MMM dd, yyyy")
                      }}</b
                    >
                  </ng-container>
                </div>
                <div
                  i18n
                  class="terms-block pointer"
                  (click)="openTncModal(each, true , true)"
                >Terms & Conditions</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="mobile-container d-block d-md-none">

      <!-- <div>
          <section class="detail-img-sec relative">
              <img class="img-fluid w100" loading="lazy"
                  default="https://images.poshvine.com/b/default-thumbnail-image.jpg"
                  [src]="offersList[0]?.attributes?.image_url">
              <div class="img-overlay absolute h100 w100"></div>
          </section>


      </div> -->

      <section class="pad-top-0 pad-15 d-none">
        <section class="abt-box flex abt-sec pad-15 bg-white">
          <div class="m-logo">
            <img class="img-fluid" default="https://images.poshvine.com/b/default-thumbnail-square.jpg"
            [src]="merchant?.attributes?.logo_url">
          </div>
          <div class="abt-info pad-left-10">
            <h3 class="fnt-16 f600"><ng-container i18n>About</ng-container> {{merchant?.attributes?.name}}</h3>
            <div class="fnt-12 ln-20">{{merchant?.attributes?.description | cleanHtml}}</div>
            <a (click)="sendMerchantAnalyticsData('go_to_website')" [href]="merchant?.attributes?.website" target="_blank" rel="noreferrer noopener" class="mar-top-10 btn fnt-14 f500 g-w-btn text-white">Go to website</a>
          </div>
        </section>

      <section
        class="pad-10 pad-left-15 pad-right-15 info-sec mar-top-18 infos bg-white"
      >
        <div class="flex align-center">
          <img
            src="https://images.poshvine.com/icon/calendar.svg"
            alt="calendar"
          />
          <span class="mar-left-10 fnt-13"
            ><ng-container i18n>Valid till</ng-container> :
            <b>{{
              offersList[activeOffer].attributes.end_date
                | date
                  : (locale === "zh-TW" ? "MMM dd日, yyyy" : "MMM dd, yyyy")
            }}</b></span
          >
        </div>
        <div class="divider mar-top-12 mar-bot-12 flex w100">
          <span></span>
        </div>

        <accordion [isAnimated]="true">
          <accordion-group>
            <div class="flex align-center" accordion-heading>
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.88729 0.965332C3.53824 0.965332 0 4.59054 0 9.04648C0 13.5024 3.53824 17.1276 7.88729 17.1276C12.2363 17.1276 15.7746 13.5024 15.7746 9.04648C15.7746 4.59054 12.2363 0.965332 7.88729 0.965332ZM8.67602 13.0871H7.09856V8.23837H8.67602V13.0871ZM8.67602 6.62214H7.09856V5.00591H8.67602V6.62214Z"
                  fill="#212529"
                />
              </svg>
              <span i18n class="mar-left-10 fnt-13">Offer Details</span>
              <svg
                class="absolute d-icon"
                width="8"
                height="5"
                viewBox="0 0 8 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.16443 1.14844L4.23171 3.84215L7.29899 1.14844"
                  stroke="#787878"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="tab-details fnt-10"
              [innerHtml]="offersList[activeOffer]?.attributes.description"
            ></div>
          </accordion-group>
          <div class="divider mar-top-12 mar-bot-12 flex w100">
            <span></span>
          </div>
          <accordion-group>
            <div class="flex align-center" accordion-heading>
              <svg
                width="15"
                height="19"
                viewBox="0 0 15 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.50546 13.0223H10.5164V14.8182H3.50546V13.0223ZM3.50546 9.43072H10.5164V11.2265H3.50546V9.43072ZM8.76365 0.45166H1.75273C0.788729 0.45166 0 1.25978 0 2.24747V16.614C0 17.6017 0.779965 18.4098 1.74397 18.4098H12.2691C13.2331 18.4098 14.0218 17.6017 14.0218 16.614V5.83909L8.76365 0.45166ZM12.2691 16.614H1.75273V2.24747H7.88729V6.737H12.2691V16.614Z"
                  fill="#212529"
                />
              </svg>

              <span i18n class="mar-left-10 fnt-13">Terms & Conditions</span>
              <svg
                class="absolute d-icon"
                width="8"
                height="5"
                viewBox="0 0 8 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.16443 1.14844L4.23171 3.84215L7.29899 1.14844"
                  stroke="#787878"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="tab-details fnt-10"
              [innerHtml]="offersList[activeOffer]?.attributes?.terms"
            ></div>
          </accordion-group>
        </accordion>
      </section>
    </section>
    <section>
      <a (click)="backClicked()" class="flex p-3 align-center">
        <img
          class="mr-2 back-btn"
          src="https://images.poshvine.com/icon/left-arrow.svg"
          alt="left arrow"
        />
        <p class="m-0 text-base">Back</p>
      </a>
      <div class="detail-img-sec relative">
        <img
          class="img-fluid w100"
          loading="lazy"
          default="https://images.poshvine.com/b/default-thumbnail-image.jpg"
          [src]="offersList[0]?.attributes?.image_url"
        />
        <div class="img-overlay absolute h100 w100"></div>
        <div class="modal-mer-logo">
          <img
            class="img-fluid"
            loading="lazy"
            default="https://images.poshvine.com/b/default-thumbnail-square.jpg"
            [src]="merchant?.attributes?.logo_url"
          />
        </div>
      </div>
    </section>
    <section class="bor-t relative">
      <div class="offers-parent pad-15 mb-5 multi-sec-4 single-j">
        <div>
          <div class="offer-nav flex mar-top-22" *ngIf="offersList?.length > 1">
            <div
              class="offer-btn cfff fnt-12 flex align-center justify-center"
              [ngClass]="{ activeOffer: i == activeOffer }"
              *ngFor="let each of offersList; let i = index"
              (click)="activeOffer = i"
            >
              <ng-container i18n>Offer</ng-container>{{ " " + (i + 1) }}
            </div>
          </div>

          <div>
            <div class="offers-single pad-15 mar-bot-8">
              <h2 class="mt-1 mb-4 fnt-20">
                {{ merchant?.attributes?.name }}
              </h2>
              <div
                class="c-555 multi-d"
                [innerHtml]="offersList[activeOffer].attributes.description"
              ></div>
              <div
                class="separator-line mar-top-20"
                *ngIf="offersList[activeOffer].attributes.end_date"
              ></div>
              <div
                class="flex space-between align-center"
                *ngIf="offersList[activeOffer].attributes.end_date"
              >
                <div class="flex mb-4">
                  <div class="val-icon">
                    <img
                      class="mr-2 calendar-icon"
                      src="https://images.poshvine.com/icon/calendar.svg"
                      alt="calendar"
                    />
                  </div>
                  <div class="v-lbl c3F3D3D fnt-12 pad-top-1 mar-right-10 mt-1">
                    <ng-container i18n>Valid till</ng-container> :
                    <b class="f600">{{
                      offersList[activeOffer].attributes.end_date
                        | date
                          : (locale === "zh-TW"
                              ? "MMM dd日, yyyy"
                              : "MMM dd, yyyy")
                    }}</b>
                  </div>
                </div>
              </div>
              <p-accordion>
                <p-accordionTab>
                  <ng-template pTemplate="header">
                    <span>
                      <ng-container i18n>About</ng-container
                      >{{ " " + merchant?.attributes?.name }}</span
                    >
                  </ng-template>
                  <div
                    class="fnt-12"
                    [innerHTML]="merchant?.attributes?.description"
                  ></div>
                </p-accordionTab>
                <p-accordionTab header="Terms & Conditions">
                  <div
                    class="fnt-12"
                    [innerHtml]="offersList?.[activeOffer]?.attributes?.terms"
                  ></div>
                </p-accordionTab>
              </p-accordion>
            </div>
            <!-- claim buttons -->
            <section class="flex justify-center align-center mb-3">
              <div
                *ngIf="loadingRedemptions"
                class="flex load-contain pad-right-35 pad-top-20 w100"
              >
                <div class="loader1 dot-spin"></div>
              </div>
              <ng-container *ngIf="!loadingRedemptions">
                <ng-container *ngIf="isAuthenticated">
                  <button
                    id="gtm-offer-detail-claim-btn"
                    class="ga-click gen-c-btn primary-btn btn brand-btn rounded-pill col-8 text-white claim-btn"
                    (click)="redeem(offersList[activeOffer])"
                    [disabled]="offersList[activeOffer].showLoader"
                  >
                    <div class="d-flex align-center justify-content-center">
                      <div i18n>Claim offer</div>
                      <div
                        class="loader mar-left-10"
                        *ngIf="offersList[activeOffer].showLoader"
                      ></div>
                    </div>
                  </button>
                </ng-container>
                <ng-container *ngIf="!isAuthenticated">
                  <button
                    id="gtm-offer-detail-claim-btn"
                    class="ga-click gen-c-btn primary-btn btn brand-btn rounded-pill col-8 text-white claim-btn"
                    (click)="redeem(offersList[activeOffer])"
                  >
                    <div class="d-flex align-center justify-content-center">
                      <div i18n>Claim offer</div>
                    </div>
                  </button>
                </ng-container>
              </ng-container>
            </section>
          </div>
        </div>
      </div>
    </section>
    <div class="slide-menu-content bg-white" *ngIf="showMobTnc">
      <div class="close-btn flex justify-end">
        <span
          class="icon-cancel"
          (click)="showMobTnc = false; removeModalOpen()"
        ></span>
      </div>
      <div class="no-margin li-margin-bottom-12">
        <section class="heading-sec flex align-center modal-head-sec">
          <div class="merchant-logo">
            <img
              class="img-fluid"
              loading="lazy"
              default="https://images.poshvine.com/b/default-thumbnail-square.jpg"
              [src]="merchant?.attributes?.logo_url"
            />
          </div>
          <h2 class="no-margin fnt-20">{{ merchant?.attributes?.name }}</h2>
        </section>

        <div class="term-sec">
          <h4 i18n class="mar-bot-15 fnt-14" *ngIf="inputToShow == 'tnc'">Terms & Conditions</h4>
          <div
            class="fnt-12"
            [innerHtml]="offersList[activeOffer]?.attributes?.terms"
            *ngIf="inputToShow == 'tnc'"
          ></div>
          <div
            class="fnt-12"
            [innerHtml]="merchant?.attributes?.description"
            *ngIf="inputToShow == 'desc'"
          ></div>
        </div>
      </div>
    </div>
  </section>
</div>

<app-loader *ngIf="progress"></app-loader>